import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Navbar } from "@/components/Navbar";
import { useAuth } from "@/context/AuthContext";
import { api, apiError } from "@/lib/api";
import { field } from "@/pages/Auth";
import { RecoveryCodes } from "@/pages/TwoStep";

export default function AccountSecurity() {
  const { login, user } = useAuth();
  const [info, setInfo] = useState(null);
  const [code, setCode] = useState("");
  const [codes, setCodes] = useState(null);
  const load = () => api.get("/account/security").then((r) => setInfo(r.data)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); }, []);
  const regen = async (e) => {
    e.preventDefault();
    try { setCodes((await api.post("/account/security/recovery-codes", { code })).data.recovery_codes); setCode(""); }
    catch (err) { toast.error(apiError(err)); }
  };
  const signOutOthers = async () => {
    if (!window.confirm("Sign out of Memories Forever on every other device?")) return;
    try { const { data } = await api.post("/account/security/sign-out-everywhere"); login(data.token, user); toast.success("Signed out on all other devices"); }
    catch (err) { toast.error(apiError(err)); }
  };
  return (
    <div className="min-h-screen legacy-bg">
      <Navbar />
      <main className="max-w-2xl mx-auto px-4 py-10 space-y-6" data-testid="account-security">
        <Link to="/admin" className="text-[#C9B6FF] underline underline-offset-4" data-testid="account-security-back">← Admin dashboard</Link>
        <h1 className="font-serif text-3xl sm:text-4xl text-[#EDE6F7]">Your security</h1>
        {info && (
          <section className="glass-card p-6 space-y-2" data-testid="account-security-status">
            <p className="text-[#EDE6F7] text-lg">Two-step verification: <span className="text-[#C9B6FF] font-semibold">{info.mfa_enabled ? "On" : "Off"}</span></p>
            <p className="text-[#B9B3C8]" data-testid="account-security-codes-left">Unused recovery codes: {info.codes_left} of 10</p>
          </section>
        )}
        <section className="glass-card p-6 space-y-4">
          {codes ? <RecoveryCodes codes={codes} doneLabel="Done" onDone={() => { setCodes(null); load(); }} /> : (
            <form onSubmit={regen} noValidate className="space-y-3" data-testid="account-regen-form">
              <h2 className="text-lg text-[#EDE6F7]">Get new recovery codes</h2>
              <p className="text-[#B9B3C8]">Your old codes stop working straight away. Enter the current code from your authenticator app.</p>
              <input inputMode="numeric" maxLength={7} placeholder="123456" className={`${field} tracking-[0.3em] text-center`} value={code} onChange={(e) => setCode(e.target.value)} data-testid="account-regen-code" />
              <button type="submit" className="gold-btn h-12 rounded-full px-6" data-testid="account-regen-submit">Create new codes</button>
            </form>
          )}
        </section>
        <section className="glass-card p-6 space-y-3">
          <h2 className="text-lg text-[#EDE6F7]">Other devices</h2>
          <button type="button" onClick={signOutOthers} className="rounded-full border border-[#8B2CFF] px-5 py-2.5 text-[#EDE6F7] hover:bg-[#241634]" data-testid="account-signout-everywhere">Sign out everywhere else</button>
        </section>
      </main>
    </div>
  );
}
